<template>
  <div class="container">
    <!-- 名称 -->
    <div class="top">
      <div class="tt">
        <van-icon name="arrow-left" color="var(--text_color)" size="20" @click="$router.go(-1)" />
        <span>{{ productInfo.name }}</span><span></span>
      </div>
    </div>
    <!-- 期限 -->
    <div class="tips">{{$t('finance').term}}<span>{{ productInfo.days }} {{$t('finance').day}}</span> </div>
    <!-- 利率 -->
    <div class="tips">{{$t('finance').Dailyinterestrate}}<span>{{ productInfo.yieldMin }}% - {{ productInfo.yieldMax }}%</span> </div>
    <!-- 投资额 -->
    <div class="tips">{{ $t('finance').investment }} <span>{{ productInfo.lowAmount }} - {{ productInfo.highAmount }} USDT</span></div>
    <van-field v-model="Amount" type="number" :placeholder="$t('finance').investment" @input="onInputAmount">
      <template #right-icon>
        <span style="color: var(--ntext_color)">USDT</span>
      </template>
    </van-field>
    <!-- 选择百分比 -->
    <div class="sliderPrecent">
      <vue-slider v-model="Amount" :min="productInfo.lowAmount" :max="productInfo.highAmount" :interval="1" :marks="{ [productInfo.lowAmount]:  [productInfo.lowAmount], [productInfo.highAmount]:  [productInfo.highAmount]}" :dot-size="15" :tooltip="'hover'"
        :rail-style="{ backgroundColor: 'var(--info_color)', height: '5px' }" :process-style="{ backgroundColor: 'var(--text_color)' }" :dot-style="{ backgroundColor: 'var(--background_color)', border: '2px solid var(--text_color)' }"
        :tooltip-style="{ backgroundColor: 'var(--info_color)', color: 'var(--text_color)', padding: '4px 8px', borderRadius: '4px' }" />
    </div>
    <!-- 可用余额 -->
    <div class="tips">{{ $t('with').availablebalance }}<span>{{ AssetBalance }} USDT</span>
    </div>
    <!-- 时间轴 -->
    <div class="lable">{{ $t('finance').timeaxis }}</div>
    <div class="timeline">
      <!-- 申购日 -->
      <div class="timeline-item">
        <div class="dot"></div>
        <div class="content">
          <div class="title">{{ $t('finance').Subscriptiondate }}</div>
          <div class="time">{{ inComeInfo.buyTime | getLocalDate }}</div>
        </div>
      </div>
      <!-- 起息日 -->
      <div class="timeline-item">
        <div class="dot"></div>
        <div class="content">
          <div class="title">{{ $t('finance').valuedate }}</div>
          <div class="time">{{ inComeInfo.interestTime | getLocalDate }}</div>
        </div>
      </div>
      <!-- 到期日 -->
      <div class="timeline-item">
        <div class="dot"></div>
        <div class="content">
          <div class="title">{{ $t('finance').duedate }}</div>
          <div class="time">{{ inComeInfo.endTime | getLocalDate }}</div>
        </div>
      </div>
    </div>
    <!-- 按钮 -->
    <van-button block :loading="btnloading" @click="handleSub">{{ $t('finance').Applynow }}</van-button>
  </div>
</template>

<script>
import productApi from '@/api/product'
import orderApi from '@/api/order'
import userApi from '@/api/user'
import { EventBus } from '@/utils/event-bus'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

export default {
  components: {
    VueSlider
  },
  data() {
    return {
      btnloading: false,
      baseUrl: window.baseURL,
      Amount: '',
      AssetBalance: 0,
      financingId: '',
      productInfo: {},
      inComeInfo: {
        dayAmount: 0,
        endAmount: 0,
        buyTime: '',
        interestTime: '',
        endTime: '',
        completeTime: ''
      },
      dragging: false,
      activePrecent: 0,//余额百分比
    }
  },
  mounted() {
    EventBus.$on('btnloading', () => {
      this.btnloading = false
    })
    if (this.$route.query.id) {
      this.financingId = this.$route.query.id
      this.getAssetBalance()
    }
  },
  methods: {
    //输入金额
    onInputAmount() {
      if (this.Amount > this.AssetBalance)
        this.$toast(this.$t('asset').Insufficientavailablebalance)
    },
    // 获取资产余额
    async getAssetBalance() {
      const res = await userApi.getAssetBalance({ assetType: '5', currency: 'USDT' })
      this.AssetBalance = res.assetWallet.amount
      this.getProductInfo()
    },
    // 产品详情
    async getProductInfo() {
      const res = await productApi.getFinanceProductInfo({ financingId: this.financingId })
      this.productInfo = res.data
      this.inComeInfo.buyTime = new Date()
      this.inComeInfo.interestTime = new Date().setDate(new Date().getDate() + 1)
      this.inComeInfo.endTime = new Date().setDate(new Date().getDate() + this.productInfo.days)
      this.Amount = this.productInfo.lowAmount
    },
    // 提交
    async handleSub() {
      if (!this.Amount) {
        this.$toast({ message: this.$t('recharge').amountMsg })
        return false
      }
      // 最低投资额
      if (this.Amount < this.productInfo.lowAmount) {
        this.$toast(this.$t('finance').Mininvestment + this.productInfo.lowAmount + ' USDT')
        return false
      }
      // 最高投资额
      if (this.Amount > this.productInfo.highAmount) {
        this.$toast(this.$t('finance').Maxinvestment + this.productInfo.highAmount + ' USDT')
        return false
      }
      // 可用余额不足
      if (this.Amount > this.AssetBalance) {
        this.$toast(this.$t('with').Insufficientavailablebalance)
        return false
      }
      const form = {
        productFinancingId: this.productInfo.financingId,
        amount: this.Amount,
      }
      this.btnloading = true
      await orderApi.createFinanceOrder(form)
      this.btnloading = false
      this.$toast(this.$t('trade').orderSuccess)
      this.$router.push({ name: 'FinanceList' })
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  width: 100%;
  background: var(--background_color);
  padding: 15px;

  .top {
    .tt {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 17px;
      font-weight: bold;
      color: var(--text_color);
    }

    .logos {
      text-align: center;
      margin-top: 10px;
      margin-right: -5px;

      img {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        margin-right: 5px;
      }
    }
  }

  .lable {
    margin-top: 20px;
    font-size: 13px;
    color: var(--text_color);
  }
  .sliderPrecent {
    margin: 20px 10px 30px 10px;

    .slable {
      margin-top: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 12px;
      color: var(--ntext_color);
    }
  }
  .tips {
    margin-top: 20px;
    display: flex;
    align-items: center;
    font-size: 13px;
    color: var(--ntext_color);

    span {
      margin-left: 10px;
      color: var(--text_color);
      font-weight: bold;
    }
  }

  .incomeInfo {
    margin-top: 10px;
    background: var(--info_color);
    border-radius: 10px;
    padding: 5px 15px 15px 15px;

    .txt {
      margin-top: 15px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 13px;
      color: var(--ntext_color);

      span {
        font-weight: bold;
        color: var(--text_color);
      }
    }
  }

  .timeline {
    margin-top: 10px;
    margin-left: 5px;
    display: flex;
    flex-direction: column;
    position: relative;

    .timeline-item {
      display: flex;
      align-items: center;
      position: relative;
      padding: 10px 0;
    }

    .dot {
      width: 8px;
      height: 8px;
      background-color: var(--ntext_color);
      border-radius: 50%;
      position: absolute;
      left: 0;
    }

    .timeline-item:not(:last-child)::after {
      content: '';
      position: absolute;
      left: 4px;
      top: 25px;
      width: 1px;
      height: 100%;
      background-color: var(--ntext_color);
    }

    .content {
      padding-left: 20px;
      display: flex;
      flex-direction: column;
    }

    .title {
      font-size: 14px;
      color: var(--text_color);
    }

    .time {
      margin-top: 10px;
      font-size: 12px;
      color: var(--ntext_color);
    }
  }

  .van-button {
    margin: 30px 0;
    background: var(--text_color);
    height: 40px;
    border-radius: 20px;
    border: 0;
    font-size: 15px;
    color: var(--background_color);
  }
}

::v-deep .van-field__value {
  overflow: visible;
  display: grid;
}

.van-cell {
  margin-top: 10px;
  background: var(--background_color);
  border: 1px solid var(--info_color);
  height: 50px;
  padding: 10px;
  border-radius: 10px;
  font-size: 16px;
  font-weight: bold;
}

::v-deep .van-field__control {
  color: var(--text_color);
}

::v-deep .van-field__right-icon {
  margin: -10px 8px;
  padding: 0px;
  line-height: normal;
  font-size: 15px;
}

::v-deep .vue-slider-dot-tooltip-inner-top::after {
  border-top-color: var(--info_color) !important;
}

::v-deep .vue-slider-mark {
  background: var(--background_color);
  width: 10px !important;
  height: 10px !important;
  border: 2px solid var(--info_color);
  border-radius: 50%;
}

::v-deep .vue-slider-mark-active {
  border: 2px solid var(--text_color);
}

::v-deep .vue-slider-mark-label {
  color: var(--ntext_color);
  font-size: 11px;
}
</style>
